import React from 'react';
import { ReactComponent as ActiveControl } from "assets/img/svg/ActiveControl.svg";
import { ReactComponent as InactiveControl } from "assets/img/svg/InactiveControl.svg";

const defaultToggleOptions = {
    onValue: { label: 'Active', value: 'ACTIVE' },
    offValue: { label: 'Inactive', value: 'INACTIVE' }
}

const AToggleButton = ({
    value,
    handleChange = () => { },
    disabled,
    toggleOptions = defaultToggleOptions,
    showText = true,
}) => {
    const { onValue, offValue } = toggleOptions;
    const isToggleOn = value === onValue?.value;

    return (
        isToggleOn
            ? <span><ActiveControl onClick={() => !disabled && handleChange(offValue?.value)} /> {showText && onValue?.label} </span>
            : <span><InactiveControl onClick={() => !disabled && handleChange(onValue?.value)} /> {showText && offValue?.label} </span>
    )

}

export default AToggleButton;